import React, { useState, useEffect } from 'react';
import { db } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import '../styles/transactions.css';
import Loader from '../components/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

const Recent = ({ user }) => {
    const [transactions, setTransactions] = useState([]);
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [userData, setUserData] = useState(null);
    const [filterType, setFilterType] = useState('all');

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const userId = user?.uid;
                if (!userId) {
                    setError('User is not authenticated.');
                    return;
                }

                const userDoc = await getDoc(doc(db, 'swiss-h', userId));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setUserData(userData);

                    let fetchedTransactions = userData.transactions || [];
                    fetchedTransactions = fetchedTransactions
                        .sort((a, b) => new Date(a.date) - new Date(b.date))
                        .slice(0)
                        .reverse();

                    setTransactions(fetchedTransactions);
                    setFilteredTransactions(fetchedTransactions);
                }
            } catch (error) {
                setError('Error fetching transactions.');
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        if (user?.uid) fetchTransactions();
    }, [user]);

    const handleCopyAccountNumber = () => {
        if (userData?.accountNumber) {
            navigator.clipboard.writeText(userData.accountNumber)
                .then(() => alert('Account number copied!'))
                .catch(err => console.error('Copy failed:', err));
        }
    };

    const filterTransactions = (type) => {
        setFilterType(type);
        setFilteredTransactions(
            type === 'all' ? transactions : transactions.filter(t => t.type === type)
        );
    };

    if (loading) return <Loader />;
    if (error) return <div>{error}</div>;

    return (
        <div className="transactions-container">

            <div className="boxed" style={{ marginBottom: "15px" }}>
                <strong>Account Number:</strong> {userData?.accountNumber || 'Loading...'}
                <FontAwesomeIcon className="copy-icon" icon={faCopy} onClick={handleCopyAccountNumber} />
            </div>

            <h2 className="transaction-head">Recent Transactions</h2>

            <div className="filter-buttons">
                {["all", "credit", "debit"].map((type) => (
                    <button
                        key={type}
                        className={`filter-button ${filterType === type ? 'active' : ''}`}
                        onClick={() => filterTransactions(type)}
                    >
                        {type.charAt(0).toUpperCase() + type.slice(1)}
                    </button>
                ))}
            </div>

            <div className="transactions-list">
                {filteredTransactions.length === 0 ? (
                    <div className="no-transactions">
                        <i className="fas fa-receipt"></i>
                        <p>No transactions yet.</p>
                    </div>
                ) : (
                    filteredTransactions.map((t, i) => (
                        <li key={i}
                            className={`transaction-item ${t.type}`}
                            onClick={() => setSelectedTransaction(t)}
                        >
                            <div className="transaction-details">
                                <div className="transaction-description">
                                    {t.description}
                                    <div className="transaction-date">
                                        {new Date(t.date).toLocaleDateString()}
                                    </div>
                                </div>
                                <div className="transaction-amount">
                                    ${t.amount.toFixed(2)}
                                </div>
                            </div>
                        </li>
                    ))
                )}
            </div>

            {/* Modal */}
            {selectedTransaction && (
                <div className="overlaid">
                    <div className="details-box show">
                        <div className="details-content">
                            {/* <div className="transaction-description-box">
                                <strong>Description:</strong> {selectedTransaction.description}
                            </div> */}

                            <h2 className='acc'>Transaction Details</h2>

                            <ul className="transaction-info">
                                <li><strong>Amount:</strong> ${selectedTransaction.amount.toFixed(2)}</li>
                                <li><strong>Type:</strong> {selectedTransaction.type}</li>
                                <li><strong>Account:</strong> {selectedTransaction.account}</li>
                                <li><strong>Description:</strong> {selectedTransaction.description}</li>
                                <li><strong>Beneficiary:</strong> {selectedTransaction.beneficiary}</li>
                                <li><strong>Date:</strong> {new Date(selectedTransaction.date).toLocaleDateString()}</li>
                            </ul>

                            <div className="button-container">
                                <span className="contact-support-button" onClick={() => setSelectedTransaction(null)}>
                                    &times; Close
                                </span>
                                <span
                                    className="closed"
                                    onClick={() => window.location.href = "mailto:support@skyhighntb.com"}
                                >
                                    Contact Support
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Recent;
